import background0 from "../../../img/nopicture/nopicturewhite.png";
import background1 from "../../../img/mobile/one-mob@1x.png";
import background2 from "../../../img/mobile/two-mob@1x.png";
import background3 from "../../../img/mobile/three-mob@1x.png";
import background4 from "../../../img/mobile/four-mob@1x.png";
import background5 from "../../../img/mobile/five-mob@1x.png";
import background6 from "../../../img/mobile/six-mob@1x.png";
import background7 from "../../../img/mobile/seven-mob@1x.png";
import background8 from "../../../img/mobile/eight-mob@1x.png";
import background9 from "../../../img/mobile/nine-mob@1x.png";
import background10 from "../../../img/mobile/ten-mob@1x.png";
import background11 from "../../../img/mobile/eleven-mob@1x.png";
import background12 from "../../../img/mobile/twelve-mob@1x.png";
import background13 from "../../../img/mobile/thirteen-mob@1x.png";
import background14 from "../../../img/mobile/fourteen-mob@1x.png";
import background15 from "../../../img/mobile/fifteen-mob@1x.png";

export const icons = [
  { id: "icon1" },
  { id: "icon2" },
  { id: "icon3" },
  { id: "icon4" },
  { id: "icon5" },
  { id: "icon6" },
  { id: "icon7" },
  { id: "icon8" },
];

export const backgrounds = [
  { id: background0, class: "background0" },
  { id: background1, class: "background1" },
  { id: background2, class: "background2" },
  { id: background3, class: "background3" },
  { id: background4, class: "background4" },
  { id: background5, class: "background5" },
  { id: background6, class: "background6" },
  { id: background7, class: "background7" },
  { id: background8, class: "background8" },
  { id: background9, class: "background9" },
  { id: background10, class: "background10" },
  { id: background11, class: "background11" },
  { id: background12, class: "background12" },
  { id: background13, class: "background13" },
  { id: background14, class: "background14" },
  { id: background15, class: "background15" },
];
